<template>
	<div class="dropdown dropdown-wp" :class="{'show': active}">
		<button
		class="btn"
		type="button"
		data-toggle="dropdown"
		aria-haspopup="true"
		aria-expanded="false"

		@click="togglenMenu()"
		:class="buttonclass"
		:id="id">
			{{ value ? getValueText(value) : $t(buttontext) }}
		</button>
		<div class="dropdown-menu" :class="{'show': active}" :aria-labelledby="id">
			<a
			href="javascript:void(0)"
			class="dropdown-item"

			:class="{'dropdown-item--active': item.value == value}"
			v-for="item in items"
			@click="itemClick(item)"
			>{{ getText(item) }}</a>
		</div>
	</div>
</template>

<script>

/**
import Dropdown from '@/components/Dropdown';

 *

<Dropdown :items="['Bitte wählen', 'Pascal', 'Stefan', 'Sven']" v-model="active"></Dropdown>

<Dropdown :items="['Bitte wählen', 'Pascal', 'Stefan', 'Sven']" v-model="active" :id="Cool" :buttontext="Standart Button text"></Dropdown>

 */
import forEach from 'lodash/forEach';
export default {
	name: 'Dropdown',
	data() {
		return {
			active: false,
		}
	},
	props: {
		value: {
			default: false
		},
		id: {
			type: String,
			default: 'dropdownMenuButton'
		},
		buttontext: {
			type: String,
			default: 'please select'
		},
		buttonclass: {
			type: String,
			default: 'btn-secondary'
		},
		items: {
			type: Array,
			default(){
				return [];
			}
		}
	},
	methods: {
		scrollToActiveItem(){
			var self = this;
			var activeItem = self.$el.querySelector('.dropdown-item--active');



			if(activeItem) {
				this.$nextTick(function () {

					var menuItem = self.$el.querySelector('.dropdown-menu'),
						react = menuItem.getBoundingClientRect(),
						top = activeItem.offsetTop;

					menuItem.scrollTop = top;
				});
			}
		},
		togglenMenu(){
			this.active = !this.active
			if(this.active) this.scrollToActiveItem();
		},
		itemClick(item){
			this.$emit('input', this.getValue(item));
			this.$emit('onChange', this.getValue(item));
			this.togglenMenu();
		},
		getValue(option, index){
			let val = false;
			if(Array.isArray(this.items)){
				if(typeof option == 'object' && option.value){
					val =  option.value;
				} else {
					val = option;
				}
			} else {
				val = index;
			}

			if(typeof val === 'number') val = val.toString();
			return val;
		},
		getText(opt, index){
			if(typeof opt === 'string') {
				return opt;
			} else if(opt.label){
				if(opt.translate) {
					return this.$t(opt.label).trim();
				}

				return opt.label;
			}

			if(typeof this.items[opt] !== 'undefined') {
				return this.getText(this.items[opt]);
			} else if(typeof this.items[index] !== 'undefined') {
				return this.getText(this.items[index]);
			}

			return false;
		},
		getValueText(value){
			var out = [];
			forEach(this.items, (obj) => {
				if(typeof obj === "string" && obj === value){
					out.push(this.getText(obj));
				} else if(obj.value == value){
					out.push(this.getText(obj));
				}
			});
			if(out.length <= 0) return false;
			return out.length > 1 ? out : out[0];
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Forms/Dropdown.vue